export default __webpack_public_path__ + "static/120-8da1e0ab8e65fdfaab67c9636c4f1600.jpg";